import {
  QueryClient,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { fetchCreateRollCompetitionEntrie } from './service';
import { RollCompetitionsEntriesQueryKeys } from '../../queryKey';
import { RollCompetitionEntries } from '@/models/roll-competition/entries';
import { useDispatch } from 'react-redux';
import {
  setIsAnimatingRollPointGame,
  setRollPointResult,
} from '@/lib/store/roll-point/actions';

export function useCreateRollCompetitionEntries() {
  const dispatch = useDispatch();
  const queryClient: QueryClient = useQueryClient();

  function onSuccess(data: RollCompetitionEntries) {
    dispatch(setIsAnimatingRollPointGame(true));
    dispatch(
      setRollPointResult(
        String(data?.rolled)?.padStart(3, '0').split('').map(Number),
      ),
    );
    queryClient.invalidateQueries({
      queryKey: [RollCompetitionsEntriesQueryKeys.Primary],
    });
    queryClient.invalidateQueries({
      queryKey: [RollCompetitionsEntriesQueryKeys.Validate],
    });
  }

  const { mutate, isPending } = useMutation({
    mutationFn: fetchCreateRollCompetitionEntrie,
    onSuccess,
  });

  return {
    createRollCompetitionEntries: mutate,
    isPending,
  };
}
